import { useReduxState } from 'hooks';
import { Form, Select } from 'components/common/form';

import type { Course } from 'shared-types';

interface Props {
  courses: Pick<Course, 'id' | 'title'>[];
  onCourseChange: (courseId: number) => void;
}

const FeedbackCourseFilter = ({ courses, onCourseChange }: Props) => {
  const { messages } = useReduxState();

  const handleCourseChange = async (courseId: number) => {
    onCourseChange(courseId);
  };

  return !courses?.length ? null : (
    <div className="courses">
      <Form initialValues={{ course: 0 }}>
        {() => (
          <Select
            ariaLabel={messages.commonFilterByCourse}
            dropdownStyles={true}
            field="course"
            id="course"
            isSearchable={true}
            onChange={handleCourseChange}
            options={[
              { label: messages.commonAllCourses, value: 0 },
              ...courses.map((course) => ({
                label: course.title,
                value: course.id
              }))
            ]}
          />
        )}
      </Form>

      <style jsx>{`
        .courses {
          display: block;
          max-width: 300px;
          width: 300px;
        }
      `}</style>
    </div>
  );
};

export default FeedbackCourseFilter;
